const createRandomName = (names) => {
    // const firstName = firstNames[Math.floor(Math.random() * firstNames.length)]
    return names[Math.floor(Math.random() * names.length)]
}
export default createRandomName
